export const FortressLogo = () => (
  <div className="flex justify-center">
    <div className="w-16 h-16 bg-fortress-gold/10 border-2 border-fortress-gold/30 rounded-2xl flex items-center justify-center transform rotate-45">
      <div className="w-8 h-8 bg-fortress-gold rounded-lg transform -rotate-45" />
    </div>
  </div>
);